import React, { useState,useEffect, Fragment } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { accreditationcurl, schoolsurl, regionurl, countyurl, gisa_association,schoolsedit } from '../../apis/urls';
import moment from 'moment'
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";
import reactSelect from "react-select";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


const EditSchoolList = () => {

    const validationSchema = yup.object({
        name: yup
            .string('Enter schoo name')
            .required('School name is required'),
        address_1: yup
            .string('Enter address')
            .required('Address is required'),
        city: yup
            .string('Enter city')
            .required('City is required'),
        state: yup
            .string('Enter state')
            .required('State is required'),
        zip: yup
            .string('Enter zip')
            .required('Zip is required'),
        email: yup
            .string('Enter email')
            .required('Email is required'),
        phone: yup
            .string('Enter phone')
            .required('Phone is required'),
        accreditation: yup
            .string('Enter accreditation')
            .required('Accreditation is required'),
        founding_date: yup
            .string('Enter founding date')
            .required('Founding date is required'),
        denomination: yup
            .string('Enter denomination')
            .required('Denomination is required'),
        enrollment: yup
            .string('Enter enrollment')
            .required('Enrollment is required'),
        grade: yup
            .string('Enter grade')
            .required('Grade is required'),
        country: yup
            .string('Enter country')
            .required('Country is required'),
        scholastic: yup
            .string('Enter scholastic')
            .required('Scholastic is required'),
        boarding: yup
            .string('Enter boarding')
            .required('Boarding is required'),
        gender: yup
            .string('Enter gender')
            .required('Gender is required'), 

    })

    const { id } = useParams();
    let urole = localStorage.getItem('userrole')

    const [result,setResult] = useState([]);
    const [county, setCounty] = useState([]);
    const [errorName, setErrorName] = useState({message:'failed'});
    const [errorEmail, setErrorEmail] = useState({message:'failed'});


    useEffect(()=> {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        CountyListing();
        AccreditListing();
    },[])

    useEffect(() => {
        editlisting();
    },[county, result]);
    
    let navigate = useNavigate();
    const RoutToList = () =>{
        navigate("/school_profile/"+id)
        
    }

    const AccreditListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: accreditationcurl,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{
            setResult(response?.data?.data?.items);
        }).catch((error) =>{
            console.log('error',error.message)
        });
    }


    const CountyListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: countyurl+'dropdown',
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{   
            setCounty(response?.data?.data?.items);
        }).catch((error) =>{
            console.log('error',error.message)
        });
    }

    const editlisting = () => {
        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: schoolsurl+"/"+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{
            reset({
                name:decode(response?.data?.data?.name),
                address_1:response?.data?.data?.address_1,
                address_2:response?.data?.data?.address_2,
                city:response?.data?.data?.city,
                state:response?.data?.data?.state,
                zip:response?.data?.data?.zip,
                email:response?.data?.data?.email,
                phone:response?.data?.data?.phone,
                fax:response?.data?.data?.fax,
                website:response?.data?.data?.website,
                status:response?.data?.data?.status,
                accreditation:response?.data?.data?.accreditation?.id,
                founding_date:response?.data?.data?.founding_date,
                denomination:response?.data?.data?.denomination,
                enrollment:response?.data?.data?.enrollment,
                grade:response?.data?.data?.grade_level,
                country: response?.data?.data?.county?.id,
                scholastic:response?.data?.data?.interscholastic,
                gender:response?.data?.data?.gender,
                boarding: response?.data?.data?.day_boarding,
            })
        }).catch((error) =>{
            console.log('error',error.message)
        });
    }

    const { register, reset, control, handleSubmit, formState:{ errors }, setValue} = useForm({
        resolver: yupResolver(validationSchema)
   });

    const onEditForm = (data) => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const dataValues = {
            name :data.name,
            address_1 :data.address_1,
            address_2:data.address_2,
            city:data.city,
            state :data.state,  
            zip:data.zip, 
            email:data.email,
            phone:data.phone,
            fax:data.fax,
            website:data.website,
            status :data.status,
            accreditation_id:data.accreditation,
            founding_date:data.founding_date,
            denomination:data.denomination,
            enrollment:data.enrollment,
            grade_level:data.grade,
            gender:data.gender,
            interscholastic:data.scholastic,
            day_boarding:data.boarding,
            county_id:data.country
        }
        console.log(dataValues)
        
        const instance = axios.create({
            baseURL: schoolsurl+'/general/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
          });

        instance.put('',dataValues).then((response) =>{

            if(urole === 'SUPERADMIN'){
                navigate("/school_list")
            }else if(urole === 'HO_SCHOOL'){
                navigate("/school_profile/"+id)
            }
              
           
        }).catch((error) =>{
            
            console.log('error',error.message)
        });

    }

    const validation = (type, text) => {
           
        const data = {
            type: type,
            text: text,
            id: id
        }

        const instance = axios.create({
            baseURL: `${schoolsurl}/validation/exist/check`,
            timeout: 1000000
        });

        instance.post('', data).then(res => {
            if(type === 'email'){
                setErrorEmail(res.data)
            }

            if(type === 'name'){
                setErrorName(res.data)
            }
        }).catch(err => {
            console.log(err)
        });   
    
    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Edit School List</h2>
                        </div>
                        <div className="page-rightside-action-column">   
                        </div>                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            {
                                urole === 'SUPERADMIN'?
                                (<li className="breadcrumb-item"><Link to="/school_list">School List</Link></li>)
                                :null
                            }
                            <li className="breadcrumb-item active" aria-current="page">Edit School List</li>
                        </ol>
                    </nav>

                    <form onSubmit={handleSubmit(onEditForm)} className="needs-validation">
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Name <span style={{color: "red"}}>*</span></label>
                                                {
                                                    (errorName?.message === 'pending' && !errors?.name?.message) ?
                                                    <i className="icon-notice1 iconemail-pending"></i> :
                                                    (errorName?.message === 'failed' && !errors?.name?.message) ?
                                                    <i className="icon-checkmark3 iconemail-valid"></i> : 
                                                    (errorName?.message === 'success' || errors?.name?.message) ?
                                                    <i className="icon-cancel2 iconemail-invalid"></i> : null
                                                }
                                                <input
                                                {...register('name', {
                                                    onChange: (e) => {validation('name', e.target.value)},
                                                    onBlur: (e) => {},
                                                })}
                                                name="name" 
                                                type="text" 
                                                className="form-control bg-dark dark-theme showtext" 
                                                id="name" />
                                                <div className="error-school">{errors?.name?.message}</div>
                                                <div className="error-school">{errorName?.message === 'success' && "School Name Already Exist"}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Address 1 <span style={{color: "red"}}>*</span></label>
                                                <input {...register('address_1')} name="address_1" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                <div className="error-school">{errors?.address_1?.message}</div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Address 2</label>
                                                <input {...register('address_2')} name="address_2" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">City <span style={{color: "red"}}>*</span></label>
                                                <input {...register('city')} name="city" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                <div className="error-school">{errors?.city?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">State <span style={{color: "red"}}>*</span></label>
                                                <input {...register('state')} name="state" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                <div className="error-school">{errors?.state?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Zip Code <span style={{color: "red"}}>*</span></label>
                                                <input {...register('zip')} name="zip" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                <div className="error-school">{errors?.zip?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Phone No <span style={{color: "red"}}>*</span></label>
                                                <input {...register('phone')} name="phone" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                <div className="error-school">{errors?.phone?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Fax</label>
                                                <input {...register('fax')} name="fax" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Website</label>
                                                <input {...register('website')} name="website" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Email <span style={{color: "red"}}>*</span></label>
                                                {
                                                    (errorEmail?.message === 'pending' && !errors?.email?.message) ?
                                                    <i className="icon-notice1 iconemail-pending"></i> :
                                                    (errorEmail?.message === 'failed' && !errors?.email?.message) ?
                                                    <i className="icon-checkmark3 iconemail-valid"></i> : 
                                                    (errorEmail?.message === 'success' || errors?.email?.message) ?
                                                    <i className="icon-cancel2 iconemail-invalid"></i> : null
                                                }
                                                <input 
                                                {...register('email', {
                                                    onChange: (e) => {validation('email', e.target.value)},
                                                    onBlur: (e) => {},
                                                })}
                                                name="email" 
                                                type="text" 
                                                className="form-control bg-dark dark-theme showtext" 
                                                id="name"
                                                />
                                                <div className="error-school">{errors?.email?.message}</div>
                                                <div className="error-school">
                                                    {errorEmail?.message === "success" && "Email already exist"}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="degreehead">Accreditations <span style={{color: "red"}}>*</span></label>
                                                <select {...register('accreditation')} name="accreditation" className="form-control bg-dark dark-theme showtext" id="status-selector">
                                                    <option value="">Select Accreditations</option>
                                                    {
                                                        result?.map((item,index)=>(
                                                                <option key={index} value={item.id}>{item.name}</option>    
                                                            )
                                                        )
                                                    }
                                                </select>
                                                <div className="error-school">{errors?.accreditation?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="degreehead">County<span style={{color: "red"}}>*</span></label>
                                                <select {...register('country')} name="country" className="form-control bg-dark dark-theme showtext" id="status-selector">
                                                    <option value="">Select County</option>
                                                    {
                                                        county?.map((item,index)=>(
                                                                <option key={index} value={item.id}>{item.name}</option>    
                                                            )
                                                        )
                                                    }
                                                </select>
                                                <div className="error-school">{errors?.country?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Founding Date <span style={{color: "red"}}>*</span></label>
                                                <input {...register('founding_date')} name="founding_date" type="date" className="form-control bg-dark dark-theme showtext" id="name" />
                                                <div className="error-school">{errors?.founding_date?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Denomination <span style={{color: "red"}}>*</span></label>
                                                <select {...register('denomination')} name="denomination" className="form-control bg-dark dark-theme showtext" id="status-selector">
                                                    <option value="">Select Denomination</option>
                                                    <option value="Non-Denominational" >Non-Denominational</option>
                                                    <option value="Catholic">Catholic</option>
                                                    <option value="Episcopal">Episcopal</option>
                                                    <option value="Jewish">Jewish</option>
                                                    <option value="Baptist">Baptist</option>
                                                    <option value="Mennonite">Mennonite</option>
                                                    <option value="Lutheran">Lutheran</option>
                                                    <option value="Quaker">Quaker</option>
                                                    <option value="United Mehtodist">United Mehtodist</option>
                                                    <option value="Christian">Christian</option>
                                                    <option value="Islamic">Islamic</option>
                                                </select>
                                                <div className="error-school">{errors?.denomination?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">TOTAL Enrollment (All Grades) <span style={{color: "red"}}>*</span></label>
                                                <input {...register('enrollment')} name="enrollment" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                <div className="error-school">{errors?.enrollment?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Grade Levels (Ex. K-12, 9-12) <span style={{color: "red"}}>*</span></label>
                                                <input {...register('grade')} name="grade" type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                <div className="error-school">{errors?.grade?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Gender <span style={{color: "red"}}>*</span></label>
                                                <select {...register('gender')} name="gender" type="password" className="form-control bg-dark" id="state">
                                                    <option value="">Select Gender</option>
                                                    <option value="Co-ed">Co-ed</option>
                                                    <option value="Boys">Boys</option>
                                                    <option value="Girls">Girls</option>
                                                </select>
                                                <div className="error-school">{errors?.gender?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Day Boarding <span style={{color: "red"}}>*</span></label>
                                                <select {...register('boarding')} name="boarding" type="password" className="form-control bg-dark" id="state">
                                                    <option value="">Select Day Boarding</option>
                                                    <option value="Day Only">Day Only</option>
                                                    <option value="Boarding Only" >Boarding Only</option>
                                                    <option value="Day and Boarding" >Day & Boarding</option>
                                                    <option value="Day and Girls Boarding" >Day & Girls Boarding</option>
                                                    <option value="Day and Boys Boarding" >Day & Boys Boarding</option>
                                                </select>
                                                <div className="error-school">{errors?.boarding?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Interscholastic - HS Athletics with GIAA <span style={{color: "red"}}>*</span></label>
                                                <select {...register('scholastic')} name="scholastic" type="password" className="form-control bg-dark" id="state">
                                                    <option value="">Select Interscholastic</option>
                                                    <option value="YES">YES</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                <div className="error-school">{errors?.scholastic?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                                                <select {...register('status')} name="status" className="form-control bg-dark dark-theme showtext" id="status-selector">
                                                    <option value="ACTIVE">ACTIVE</option>
                                                    <option value="INACTIVE">INACTIVE</option>
                                                    <option value="DELETED">DELETED</option>
                                                </select>                        
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <h6 style={{color: "red"}}>* Required Fields</h6>   
                                        </div>                                     
                                            

                                        <div className="col-md-6">
                                            <div className="form-group text-right">
                                            {
                                                urole === 'HO_SCHOOL' ?
                                                (null):
                                                <Fragment>
                                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                                </Fragment>}
                                                <button className="btn btn-primary btn-gisa" type="submit">Update</button>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>


                </div>
            </aside>
        </div>
    )
}

export default EditSchoolList;
